import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';
import 'rxjs/add/operator/toPromise';
import { Router } from '@angular/router';
import { CustomHttp } from '../../shared/custom.http';
import { GeneralConstants } from '../../shared/general.constants';
import { ConfigService } from '../../shared/config.service';


@Injectable()
export class DatahealthService {

    private datahealthURL = '/datahealth';  // URL to web api


    constructor(private router: Router, private customHttp: CustomHttp,
        private http: Http, private generalConstants: GeneralConstants, private configService: ConfigService) {
    }

    getMapping(titleId: any, status: any, contentType: any) {
        let url;
        if (status === true) {
            url = `${this.datahealthURL}?titleId=${titleId}&status=true&content_type=${contentType}`;
        } else {
            url = `${this.datahealthURL}?titleId=${titleId}&content_type=${contentType}`;
        }
        return this.customHttp.get(url, { body: '' });
    }

    deleteMapping(source: string, request: any, contentType) {
        const url = `${this.datahealthURL}/delete?source=` + source + `&content_type=` + contentType;
        return this.customHttp.put(url, JSON.stringify(request));
    }

    updateMapping(source: string, request: any, contentType) {
        const url = `${this.datahealthURL}?source=` + source + `&content_type=` + contentType;
        return this.customHttp.put(url, JSON.stringify(request));
    }

    handleMappingRequest(id: number, state: string, contentType) {
        let isAccept = false;
        if (state === 'approve') {
            isAccept = true;
        }
        const userName = localStorage.getItem('userName');

        const url = `${this.datahealthURL}/request?accept=${isAccept}&content_type=${contentType}&idMappingRequest=${id}&userName=${userName}`;
        return this.customHttp.get(url, { body: '' });
    }


    createMapping(source: string, request: any, contentType) {
        const url = `${this.datahealthURL}?source=` + source + `&content_type=` + contentType;
        return this.customHttp.post(url, JSON.stringify(request));
    }


    getMappingRequestTitleByState(state: string, contentType) {
        const url = `${this.datahealthURL}/request?state=` + state + `&content_type=` + contentType;
        return this.customHttp.get(url, { body: '' });
    }

    getMappingRequestTitleByStateNId(state: string, titleId: string, contentType) {
        const url = `${this.datahealthURL}/request?state=${state}&titleId=${titleId}&content_type=${contentType}`;
        return this.customHttp.get(url, { body: '' });
    }

    getLastCheckedDateForTitle(titleId: string, contentType) {
        const url = `${this.datahealthURL}/checkin?titleId=${titleId}&content_type=${contentType}`;
        return this.customHttp.get(url, { body: '' });
    }

    updateCheckedDateForTitle(titleId: string, requestUser: string, contentType) {
        const url = `${this.datahealthURL}/checkin?titleId=${titleId}&checkin=true&userName=${requestUser}&content_type=${contentType}`;
        return this.customHttp.get(url, { body: '' });
    }

    getYoutubeVideos(searchTerm: string, pageToken: string) {
        let url = `${this.generalConstants.getYoutubeApiUrl()}?part=snippet` +
            `&maxResults=${this.generalConstants.getYoutubeMaxResults()}` +
            `&key=${this.configService.getYoutubeApiKey()}&type=video&q=${encodeURIComponent(searchTerm)}`;
        if (pageToken) {
            url += `&pageToken=${pageToken}`;
        }
        return this.http.get(url)
            .map(res => res.json())
            .toPromise();
    }

    getYoutubeChannel(channelId: string) {
        const baseUrl = this.generalConstants.getYoutubeApiUrl().replace('/search', '');
        const url = `${baseUrl}/channels?id=${channelId}` +
            `&key=${this.configService.getYoutubeApiKey()}` +
            `&maxResults=50&part=snippet,statistics,contentDetails,brandingSettings`;
        console.log('YouTube Channel API URL:', url);
        return this.http.get(url)
            .map(res => {
                console.log('YouTube Channel API Response:', res.json());
                return res.json();
            })
            .toPromise()
            .catch(error => {
                console.error('YouTube Channel API Error:', error);
                throw error;
            });
    }

}



// WEBPACK FOOTER //
// ./src/app/catalogue/datahealth/datahealth.service.ts